export default __webpack_public_path__ + "static/media/alex-gibson-headshot-min.d8770157.jpeg";